import {getMappingForField} from '../constants/field-mappings';
import {TranslationFn} from '../types/common-types';

/**
 * Traduit une valeur en utilisant le mapping approprié pour le champ
 */
export const translateValue = (value: unknown, fieldPath: string, t: TranslationFn): unknown => {
  if (value === null || value === undefined) return value;

  // Traitement des tableaux
  if (Array.isArray(value)) {
    const mapping = getMappingForField(fieldPath);
    return mapping ? value.map((item) => mapping[item as string] || item) : value;
  }

  // Traitement des strings
  if (typeof value === 'string') {
    // Cas spécial : filtres avec virgules
    if (fieldPath.includes('filters') && value.includes(',')) {
      return value.split(',').map((s) => s.trim());
    }
    const mapping = getMappingForField(fieldPath);
    return mapping ? mapping[value] || value : value;
  }

  return value;
};

/**
 * Génère le label d'un champ à partir de son chemin
 */
export const getFieldLabel = (path: string, t: TranslationFn): string => {
  // Si c'est un filtre custom
  if (path.startsWith('config.possibleFilters.')) {
    const filterName = path.replace('config.possibleFilters.', '');
    return t(`pages.pilotage-rh.indicators.fields.filters.${filterName}`);
  }
  // Si c'est un filtre
  if (path.startsWith('config.filters.')) {
    const filterName = path.replace('config.filters.', '');
    return t(`pages.pilotage-rh.indicators.fields.filters.${filterName}`);
  }
  if (path.startsWith('config.')) {
    const configField = path.replace('config.', '');
    return t(`pages.pilotage-rh.indicators.fields.${configField}`);
  }
  return t(`pages.pilotage-rh.indicators.fields.${path}`);
};
